import { render, staticRenderFns } from "./EditSolutions.vue?vue&type=template&id=241c510f&scoped=true&"
import script from "./EditSolutions.vue?vue&type=script&lang=js&"
export * from "./EditSolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c510f",
  null
  
)

export default component.exports